import dashboardService from "../../../services/dashboardService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_GETBYASSIGNEDTO } from "../../../utils/constants";
import { TicketsByAssignTo } from "../../../models/Dashboard";

const useGetByAssignedTo = (year: number) =>
  useQuery<TicketsByAssignTo[], Error>({
    queryKey: [CACHE_KEY_GETBYASSIGNEDTO, year],
    queryFn: () => dashboardService.GetTicketByAssignTo(year),
  });

export default useGetByAssignedTo;
